const doc = [({"da":({"js":({"admin":({"layout":({"slide_menu":({"time_and_reimbursement":"Tid og Refusion"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;